import { useTranslation } from 'react-i18next';

import { namespaces } from '@sternum/web/services/i18n';

import { HeaderDecorationImg } from './HeaderDecorationImg';

import { Container, DecorationIconWrapper, TextContent, TitleBottom, TitleTop } from './Header.style';

export function Header() {
  const { t } = useTranslation(namespaces.auth);

  return (
    <Container role="main" aria-label="Header of auth container">
      <TextContent>
        <TitleTop>{t('welcomeTo')}</TitleTop>
        <TitleBottom>{t('sternumPlatform')}</TitleBottom>
      </TextContent>

      <DecorationIconWrapper>
        <HeaderDecorationImg />
      </DecorationIconWrapper>
    </Container>
  );
}
